import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { actions as clipperMovieActions } from '../../actions/clipperMovie';

const Container = styled.div`
  margin: 1rem calc(4rem - 9px);
`;

const ScrubberBar = styled.input`
  -webkit-appearance: none;
  height: 2px;
  width: 100%;

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    border: 2px solid rgb(70, 144, 254);
    height: 20px;
    width: 20px;
    border-radius: 50%;
    background: white;
  }

  &:focus {
    outline: none;
  }
`;

const TimeCodeDisplay = styled.output`
  position: relative;
  top: -2.5rem;
  color: rgb(108, 107, 107);
  font-family: Verdana;
  font-size: 10pt;
  line-height: 24px;
  text-align: center;
`;

class Scrubber extends Component {
  shouldComponentUpdate(nextProps) {
    return nextProps.position !== this.props.position;
  }
  render() {
    const percent = this.props.position / 10;
    const scrubberBarBackground = `linear-gradient(to right, rgb(70, 144, 254) 0%, rgb(70, 144, 254) ${percent}%, rgb(169, 167, 167) ${percent}%, rgb(169, 167, 167) 100%)`;
    const timeCodePosition = `calc(${percent}% - 44px)`;
    return (
      <Container>
        <ScrubberBar
          style={{ background: scrubberBarBackground }}
          type="range" min={0} max={1000}
          value={this.props.position}
          onMouseDown={this.props.onStartScrub}
          onMouseUp={this.props.onEndScrub}
          onChange={(event) =>
            this.props.onChangePosition(event.target.value, this.props.isPlaying)}
        />
        <TimeCodeDisplay style={{ left: timeCodePosition }}>
          {this.props.timeCode}
        </TimeCodeDisplay>
      </Container>
    );
  }
}

Scrubber.propTypes = {
  isPlaying: PropTypes.bool.isRequired,
  position: PropTypes.number.isRequired,
  timeCode: PropTypes.string.isRequired,
  onChangePosition: PropTypes.func.isRequired,
  onEndScrub: PropTypes.func.isRequired,
  onStartScrub: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
  isPlaying: state.clipperMovie.isPlaying,
  position: state.clipperMovie.currentPosition,
  timeCode: state.clipperMovie.currentTimeCode
});

const mapDispatchToProps = {
  onChangePosition: clipperMovieActions.scrubVideo,
  onEndScrub: clipperMovieActions.videoScrubEnded,
  onStartScrub: clipperMovieActions.videoScrubStarted
};

export default connect(mapStateToProps, mapDispatchToProps)(Scrubber);



// WEBPACK FOOTER //
// ./app/components/Clipper/Scrubber.js